module.exports = __webpack_public_path__ + "static/media/BJ.8c2d849d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BJ.svg
// module id = 2114
// module chunks = 7